/**
 * @generated SignedSource<<6c5d7a4616be5a25137b8722ba770e4b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteMortgageInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type PropertyMortgageFormDeleteMortgageMutation$variables = {|
  input: DeleteMortgageInput,
|};
export type PropertyMortgageFormDeleteMortgageMutation$data = {|
  +deleteMortgage: ?{|
    +deletedNodeId: string,
  |},
|};
export type PropertyMortgageFormDeleteMortgageMutation = {|
  response: PropertyMortgageFormDeleteMortgageMutation$data,
  variables: PropertyMortgageFormDeleteMortgageMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMortgagePayload",
    "kind": "LinkedField",
    "name": "deleteMortgage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedNodeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyMortgageFormDeleteMortgageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropertyMortgageFormDeleteMortgageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0792d00a6fdca7bf4fff5d8d851b424",
    "id": null,
    "metadata": {},
    "name": "PropertyMortgageFormDeleteMortgageMutation",
    "operationKind": "mutation",
    "text": "mutation PropertyMortgageFormDeleteMortgageMutation(\n  $input: DeleteMortgageInput!\n) {\n  deleteMortgage(input: $input) {\n    deletedNodeId\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "77c4926ebe04d3ba01784604bc70321d";

export default node;
